<template>
    <div id="page-404" class="page-404">
        <a href="/"><img src="/images/pufina-logo.png" alt="Logo" class="nav__logo"></a>
        <div data-aos="fade-down" data-aos-duration="3000" data-aos-delay="2500" class="header__shapes">
            <img class="header__shapes--1" src="images/bg/header-left-shape.png">
        </div>
        <div class="container">
            <div class="page-404__wrapper">
                <h3 class="page-404__info">Pagina căutată de tine nu există. Întoarce-te la Distracție în familie!</h3>
                <div class="page-404__title">404</div>
                <a class="cta cta--shadow page-404__cta" href="/">PAGINA PRINCIPALĂ &#8594;</a>
            </div>
        </div>
    </div>
</template>

<script>
export default {

}
</script>

<style scoped>
#page-404 {
    display: flex;
    flex-direction: column;
    height: 100vh;
    width: 100vw;
    align-items: center;
    justify-content: center;
    background: #cdedf9;
    padding: 15%;
}

.page-404__wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 50rem;
    text-align: center;
}

.page-404__info {
    margin: 5rem 0;
}

.page-404__title {
    font-size: 13rem;
}

.page-404__cta {
    position: relative!important;
    margin-top: 3rem;
}

@media screen and (min-width: 990px) {
    #page-404 {
        padding: 30%;
    }
}
</style>